module.exports = __webpack_public_path__ + "img/png.c50f8359.svg";